/**
 * Translation module
 *
 * All strings that contain "natural language" or phrases that are
 * presented to the user are supposed to be passed through this module
 * to make translation easier later on
 *
 * @module Translate
 * @class Translate
 */
define(
    'utils/translate',[
        'jquery',
        'strings'
    ],
    function ($, st) {
        'use strict';

        var
        /**
         * Parsed language from the HTML tag
         *
         * @property lang
         * @type {*|jQuery}
         */
        lang = $('html').attr('lang'),

        /**
         * Translation dictionary
         * Contains all the translated string
         *
         * @property s
         * @type {*}
         */
        s = (st[lang] !== undefined)? st[lang] : {};

        /**
         * Translation method
         *
         * Obviously you can name this anything you want each time you import it
         * through require js
         *
         * @method translate
         * @param string The string to be translated
         * @return {String} The translated string
         */
        return function (string) {
            return (s[string] !== undefined)? s[string] : string;
        };
    }
);
